import React from 'react';
import { Box, Typography, Container, Paper, Link } from '@mui/material';
import { Email as EmailIcon, LocationOn as LocationIcon, Business as BusinessIcon } from '@mui/icons-material';

const ContactSection = () => {
    return (
        <Box
            id="contact"
            sx={{
                py: 8,
                bgcolor: 'grey.50',
                minHeight: '60vh',
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: 6,
                    alignItems: { xs: 'center', md: 'flex-start' }
                }}>
                    {/* Left side - Header */}
                    <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography
                            variant="h3"
                            component="h2"
                            sx={{
                                fontWeight: 'bold',
                                color: 'grey.800',
                                mb: 2,
                                fontSize: { xs: '2rem', md: '3rem' }
                            }}
                        >
                            Kontakt
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                color: 'grey.600',
                                lineHeight: 1.6
                            }}
                        >
                            Nasz zespół jest do Twojej dyspozycji
                        </Typography>
                    </Box>

                    {/* Right side - Contact Info */}
                    <Box sx={{ flex: 1 }}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 4,
                                borderRadius: 3,
                                bgcolor: 'white',
                                boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                            }}
                        >
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 3
                            }}>
                                {/* Email */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <EmailIcon sx={{ color: 'primary.main', fontSize: 28 }} />
                                    <Box>
                                        <Typography variant="body2" color="grey.600" sx={{ mb: 0.5 }}>
                                            Email
                                        </Typography>
                                        <Link
                                            href="mailto:therapp.eu@gmail.com"
                                            sx={{
                                                fontSize: '1.1rem',
                                                fontWeight: 'bold',
                                                color: 'primary.main',
                                                textDecoration: 'none',
                                                '&:hover': {
                                                    textDecoration: 'underline'
                                                }
                                            }}
                                        >
                                            therapp.eu@gmail.com
                                        </Link>
                                    </Box>
                                </Box>

                                {/* Company Info */}
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                    <BusinessIcon sx={{ color: 'primary.main', fontSize: 28, mt: 0.5 }} />
                                    <Box>
                                        <Typography variant="body2" color="grey.600" sx={{ mb: 1 }}>
                                            Firma
                                        </Typography>
                                        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                            GLOBAL SPACE Sp. z o.o.
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                            <LocationIcon sx={{ color: 'grey.500', fontSize: 20, mt: 0.5 }} />
                                            <Box>
                                                <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                                                    ul. Frezerów 2, 20-209 Lublin
                                                </Typography>
                                                <Typography variant="body2" sx={{ mt: 1, color: 'grey.600' }}>
                                                    REGON: 542423809
                                                </Typography>
                                                <Typography variant="body2" sx={{ color: 'grey.600' }}>
                                                    NIP: 946275683
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Paper>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default ContactSection;
